import { useEffect, useState } from "react";
import { motionAllowed } from "../../lib/motion.js";
import type { ArtVariant } from "./palette.js";

/** How long a turning picture holds each palette before the next. */
const HOLD_MS = 5200;

/**
 * A palette that turns to the next one every few seconds, so a small piece of
 * art changes colour cell by cell as it sits there (DESIGN.md §9, "Pixel
 * art", "Turning"). Under reduced motion it keeps the first, and holds still.
 */
export function useTurningPalette(palettes: readonly ArtVariant[]): ArtVariant {
  const [index, setIndex] = useState(0);
  const count = palettes.length;
  useEffect(() => {
    if (count < 2 || !motionAllowed()) return;
    const timer = window.setInterval(() => {
      setIndex((was) => (was + 1) % count);
    }, HOLD_MS);
    return () => {
      window.clearInterval(timer);
    };
  }, [count]);
  return palettes[index % Math.max(1, count)] ?? palettes[0] ?? "sky";
}
